import { createReducer } from '@reduxjs/toolkit'
import { combineReducers } from 'redux'
import omit from 'lodash/omit'

import { storeOTP, forgetOTP, storeAuth, forgetAuth, neededBuildUpdateSlice } from './persist.actions'
import { openedPagesReducer } from './openedPages.reducer'
import { tabsReducer } from './tabs.reducer'
import gridActions from '../../features/shared/LKGrid/LKGridInstance/store/actionTypes'

const initialSession = {
  username: null,
  STK: null,
  ServerName: null,
  DisplayToken: null,
  Database: null,
  STKExpire: null,
}

const session = createReducer(initialSession, {
  [storeAuth.toString()]: (state, action) => {
    return { ...state, ...action.payload }
  },
  [forgetAuth.toString()]: (state, action) => ({ ...initialSession, username: state.username }),
})

const OTP = (state = {}, action) => {
  if (action.type === storeOTP.toString()) {
    const { username, hash, expire } = action.payload

    return {
      ...state,
      [username]: {
        hash,
        expire,
      },
    }
  }

  if (action.type === forgetOTP.toString()) {
    return omit(state, action.payload)
  }

  return state
}

function reportFilterModels(state = {}, action) {
  if (action.type === gridActions.gridState.REDUCE_FILTER_MODEL && action.meta.customId) {
    return {
      ...state,
      [action.meta.customId]: action.payload.filterModel,
    }
  }

  if (action.type === gridActions.gridState.REMOVE_FILTER_COLUMN) {
    return {
      ...state,
      [action.meta.customId]: omit(state[action.meta.customId], action.payload.colId),
    }
  }

  return state
}

//indexedDB store
export const persisted = combineReducers({
  openedPages: openedPagesReducer,
  tabs: tabsReducer,
  session,
  OTP,
  reportFilterModels,
  neededBuildUpdate: neededBuildUpdateSlice.reducer,
})
